module.exports = __webpack_public_path__ + "media/images/okra-offers/frame-2ac090b9201a73a6ccb1c80f8b79c120.png";